// src/features/game/components/bottomsheets/StarPointConsumeSheet.tsx
import React from 'react';
import { AlertCircle, Star } from 'lucide-react';

interface StarPointConsumeSheetProps {
  points: number;
  reward: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const StarPointConsumeContent: React.FC<StarPointConsumeSheetProps> = ({
  points,
  reward,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="p-6 space-y-6">
      {/* 타이틀 */}
      <h2 className="text-xl font-bold text-center">
        별 포인트 {points}개가
        <br />
        소모됩니다
      </h2>

      {/* 보유 별 */}
      <div className="flex items-center justify-center gap-2">
        <Star className="w-6 h-6 fill-yellow-400 text-yellow-400" />
        <span className="text-lg">보유: {reward}</span>
      </div>

      {/* 안내 문구 */}
      <p className="text-center text-gray-600">
        별 포인트 포인트를 이용하여
        <br />
        모험을 시작하시겠습니까?
      </p>

      {/* 경고 메시지 */}
      <div className="flex gap-3 p-4 bg-red-50 rounded-lg">
        <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-red-600">
          <strong>알아두세요!</strong>
          <br />
          문제풀이를 중단하더라도 소모된 별 포인트는 환원되지 않아요.
        </div>
      </div>

      {/* 버튼 그룹 */}
      <div className="space-y-3">
        <button
          onClick={onConfirm}
          className="w-full py-4 bg-cyan-500 text-white font-bold rounded-xl hover:bg-cyan-600 transition-colors"
        >
          계속하기
        </button>
        <button
          onClick={onCancel}
          className="w-full py-4 bg-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-300 transition-colors"
        >
          다음에 할래요
        </button>
      </div>
    </div>
  );
};
